import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanUpdateArgs, Scan } from "types/generated";

export const SCAN_UPDATE: TypedDocumentNode<
  { scanUpdate: Pick<Scan, "id"> },
  MutationScanUpdateArgs
> = gql`
  mutation ScanUpdate($id: ID!, $input: ScanInput!) {
    scanUpdate(id: $id, input: $input) {
      id
    }
  }
`;
